import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function IncludedSection() {
  const books = [{
    emoji: '📘',
    title: '100 Citas Mamá e Hija',
    desc: 'Momentos uno a uno para hablar, reír y fortalecer el vínculo.',
    color: 'border-blue-500',
    bg: 'bg-blue-50'
  }, {
    emoji: '📗',
    title: '100 Citas Mamá e Hijo',
    desc: 'Actividades para conectar desde el juego, la escucha y el amor.',
    color: 'border-green-500',
    bg: 'bg-green-50'
  }, {
    emoji: '📙',
    title: '100 Citas Papá e Hija',
    desc: 'Espacios únicos para reforzar seguridad, confianza y cercanía.',
    color: 'border-orange-500',
    bg: 'bg-orange-50'
  }, {
    emoji: '📕',
    title: '100 Citas Papá e Hijo',
    desc: 'Propuestas para compartir tiempo real y crear recuerdos juntos.',
    color: 'border-red-500',
    bg: 'bg-red-50'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-85">
          <div className="text-center mb-12" data-id="element-86">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-87">
              📚 ESTO ES TODO LO QUE RECIBÍS HOY
            </h2>
            <div className="w-24 h-2 bg-red-600 mx-auto rounded-full" data-id="element-88"></div>
          </div>

          <div className="space-y-6 mb-12" data-id="element-89">
            {books.map((book, idx) => <div key={idx} className={`flex flex-col md:flex-row items-center md:items-start gap-6 p-6 rounded-2xl border-2 ${book.color} ${book.bg} shadow-lg`} data-id="element-90">
                <div className="text-6xl md:text-7xl drop-shadow-md" data-id="element-91">
                  {book.emoji}
                </div>
                <div className="text-center md:text-left flex-1" data-id="element-92">
                  <h3 className="text-2xl font-black text-gray-900 mb-2" data-id="element-93">
                    {book.title}
                  </h3>
                  <p className="text-lg text-gray-700 mb-4 font-medium" data-id="element-94">
                    {book.desc}
                  </p>
                  <p className="inline-block bg-white px-4 py-1 rounded-full text-sm font-bold text-gray-500 border border-gray-200 shadow-sm" data-id="element-95">
                    Valor estimado: <span className="line-through" data-id="element-96">$10</span>
                  </p>
                </div>
              </div>)}
          </div>

          <div className="bg-yellow-100 border-2 border-yellow-400 p-6 rounded-xl text-center mb-10 shadow-md" data-id="element-97">
            <p className="text-xl md:text-2xl font-black text-gray-900" data-id="element-98">
              👉 Un solo pack.
              <br className="md:hidden" data-id="element-99" /> 👉 Todos los vínculos padres e hijos
              cubiertos.
            </p>
          </div>

          <CTAButton text="🔥 QUIERO CONECTAR CON MIS HIJOS HOY" data-id="element-100" />
        </motion.div>
      </div>
    </section>;
}